module.exports = __webpack_public_path__ + "img/Groupe 524.5c210a0f.svg";